import { useRef, useEffect, useReducer, useState } from 'react';
import axios from 'axios';

export default function useFetch(url, query=null) {
  const cache = useRef({})
  const [refresh, setRefresh] = useState(new Date())
  const key = url + String(query && Object.entries(query))

  const initialState = {
    status: 'idle',
    error: null,
    data: {},
    refresh: () => {
      delete cache.current[key]
      setRefresh(new Date())
    }
  }

  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case 'FETCHING':
        return { ...state, status: 'fetching' }
      case 'FETCHED':
        return { ...state, status: 'fetched', data: action.payload }
      case 'ERROR':
        return { ...state, status: 'error', error: action.payload }
      default:
        return state
    }
  }, initialState)

  useEffect(() => {
    let cancelRequest = false
    if (!url) return
    dispatch({ type: 'FETCHING' })
    if (cache.current[key]) {
      const data = cache.current[key];
      dispatch({ type: 'FETCHED', payload: data })
    } else {
      const fetchData = async () => {
        try {
          const response = await axios.get(url, { params: query })
          cache.current[key] = response.data
          if (cancelRequest) return
          dispatch({ type: 'FETCHED', payload: response.data })
        } catch (error) {
          if (cancelRequest) return
          dispatch({ type: 'ERROR', payload: error.message })
        }
      }
      fetchData()
    }
    return () => { cancelRequest = true }
  }, [key, refresh])

  return state
}
